import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Endpoints } from "../shared/config/endpoints";
import { Observable, of } from "rxjs";
import { Router } from '@angular/router';
import { SalesPersonService } from './crew-services/sales-person.service';
import { TeamsService } from './crew-services/teams.service';

@Injectable({
  providedIn: "root"
})
export class TargetService {
  constructor(
    private router: Router,
    private http: HttpClient,
    private endpoints: Endpoints,
    private teamsService: TeamsService,
    private salesPersonService: SalesPersonService
  ) {
    this.getSalesPersons();
  }

  // Handle Errors
  private handleError = (error: any): Observable<any> => {
    let message = '';
    if (error) {
      if (error.error) {
        message = error.error.message;
      } else {
        message = error.message;
      }
    }
    return of(null);
  };

  // Merge Endpoints
  private get addPeriodUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.addPeriod;
  }
  get getPeriodsUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.getPeriods;
  }
  private get updatePeriodUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.updatePeriod;
  }
  private get deletePeriodUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.deletePeriod;
  }
  private get getSubPeriodsUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.getSubPeriods;
  }
  private get addTargetUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.addTarget;
  }
  get getTargetsUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.getTargets;
  }
  private get updateTargetUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.updateTarget;
  }
  private get deleteTargetUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.deleteTarget;
  }
  get getTargetListsUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.getTargetLists;
  }
  private get getTargetLimitUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.getTargetLimit;
  }
  private get getTargetPeriodsUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.getTargetPeriods;
  }
  private get getAssignedPeriodsUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.getAssignedPeriods;
  }
  private get addAssignedTargetUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.addAssignedTarget;
  }
  private get getAssignedTargetsUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.getAssignedTargets;
  }
  private get getAssignedTargetsV2Url() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.getAssignedTargetsV2;
  }
  private get deleteAssignedTargetUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.deleteAssignedTarget;
  }
  private get addAssignedTeamTargetUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.addAssignedTeamTarget;
  }
  private get getAssignedTeamTargetsUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.getAssignedTeamTargets;
  }
  private get deleteAssignedTeamTargetUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.deleteAssignedTeamTarget;
  }
  get getCommissionsUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.getCommissions;
  }
  private get addAssignedCommissionUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.addAssignedCommission;
  }
  private get getAssignedCommissionsUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.getAssignedCommissions;
  }
  private get deleteAssignedCommissionUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.deleteAssignedCommission;
  }
  private get addCommissionProfileUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.addCommissionProfile;
  }
  get getCommissionProfilesUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.getCommissionProfiles;
  }
  private get updateCommissionProfileUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.updateCommissionProfile;
  }
  private get deleteCommissionProfileUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.deleteCommissionProfile;
  }
  private get getCommittalsUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.getCommittals;
  }
  private get addCommissionPaymentUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.addCommissionPayment;
  }
  private get getCommissionPaymentsUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.getCommissionPayments;
  }
  private get reverseCommissionPaymentUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.reverseCommissionPayment;
  }
  private get addCommissionProcessUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.addCommissionProcess;
  }
  private get getCommissionProcessesUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.getCommissionProcesses;
  }
  private get reverseCommissionProcessUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.reverseCommissionProcess;
  }
  private get addTargetFilterUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.addTargetFilter;
  }
  private get getTargetFiltersUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.getTargetFilters;
  }
  private get updateTargetFilterUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.updateTargetFilter;
  }
  private get deleteTargetFilterUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.deleteTargetFilter;
  }
  private get updateSubPeriodCurrencyRatesUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.updateSubPeriodCurrencyRates;
  }
  private get getCompanyTargetByIDUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.getCompanyTargetByID;
  }
  private get getAssignedTargetByIDUrl() {
    return this.endpoints.targetServiceUrl + this.endpoints.target.getAssignedTargetByID;
  }

  addPeriod(payload: any) {
    try {
      return this.http
        .post(this.addPeriodUrl, payload)
    } catch (error) {
      alert(error);
    }
  }

  getPeriods(queryString?: any) {
    try {
      return this.http
        .get(`${this.getPeriodsUrl}?${queryString || ''}`)
    } catch (error) {
      alert(error);
    }
  }

  updatePeriod(id: any, payload: any) {
    try {
      return this.http
        .put(`${this.updatePeriodUrl}${id}`, payload)
    } catch (error) {
      alert(error);
    }
  }

  deletePeriod(id: any) {
    try {
      return this.http
        .delete(`${this.deletePeriodUrl}${id}`)
    } catch (error) {
      alert(error);
    }
  }

  getSubPeriods(id: any) {
    try {
      return this.http
        .get(`${this.getSubPeriodsUrl}${id}`)
    } catch (error) {
      alert(error);
    }
  }

  addTarget(payload: any) {
    try {
      return this.http
        .post(this.addTargetUrl, payload)
    } catch (error) {
      alert(error);
    }
  }

  getTargets(queryString?: any) {
    try {
      return this.http
        .get(`${this.getTargetsUrl}?${queryString || ''}`)
    } catch (error) {
      alert(error);
    }
  }

  updateTarget(id: any, payload: any) {
    try {
      return this.http
        .put(`${this.updateTargetUrl}${id}`, payload)
    } catch (error) {
      alert(error);
    }
  }

  deleteTarget(id: any) {
    try {
      return this.http
        .delete(`${this.deleteTargetUrl}${id}`)
    } catch (error) {
      alert(error);
    }
  }

  getTargetLists(userId?: any, queryString?: any) {
    try {
      return this.http
        .get(`${this.getTargetListsUrl}${userId || ''}?${queryString || ''}`)
    } catch (error) {
      alert(error);
    }
  }

  getTargetLimit(targetId: any) {
    try {
      return this.http
        .get(`${this.getTargetLimitUrl}${targetId}`)
    } catch (error) {
      alert(error);
    }
  }

  getTargetPeriods(targetId: any) {
    try {
      return this.http
        .get(`${this.getTargetPeriodsUrl}${targetId}`)
    } catch (error) {
      alert(error);
    }
  }

  getAssignedPeriods(userId: any, targetId: any, stage?: any) {
    try {
      return this.http
        .get(`${this.getAssignedPeriodsUrl}${userId}/${targetId}?stage=${stage || ''}`)
    } catch (error) {
      alert(error);
    }
  }

  addAssignedTarget(payload: any) {
    try {
      return this.http
        .post(this.addAssignedTargetUrl, payload)
    } catch (error) {
      alert(error);
    }
  }

  getAssignedTargets(targetId: any) {
    try {
      return this.http
        .get(`${this.getAssignedTargetsUrl}${targetId}`)
    } catch (error) {
      alert(error);
    }
  }

  getAssignedTargetsV2(targetId: any) {
    try {
      return this.http
        .get(`${this.getAssignedTargetsV2Url}${targetId}`)
    } catch (error) {
      alert(error);
    }
  }

  deleteAssignedTarget(id: any, userId: any) {
    try {
      return this.http
        .delete(`${this.deleteAssignedTargetUrl}${id}/${userId}`)
    } catch (error) {
      alert(error);
    }
  }

  addAssignedTeamTarget(payload: any) {
    try {
      return this.http
        .post(this.addAssignedTeamTargetUrl, payload)
    } catch (error) {
      alert(error);
    }
  }

  getAssignedTeamTargets(targetId?: any, queryString?: any) {
    try {
      return this.http
        .get(`${this.getAssignedTeamTargetsUrl}${targetId || ''}?${queryString || ''}`)
    } catch (error) {
      alert(error);
    }
  }

  deleteAssignedTeamTarget(id: any, teamId: any) {
    try {
      return this.http
        .delete(`${this.deleteAssignedTeamTargetUrl}${id}/${teamId}`)
    } catch (error) {
      alert(error);
    }
  }

  getCommissions(userId?: any, queryString?: any) {
    try {
      return this.http
        .get(`${this.getCommissionsUrl}${userId || ''}?${queryString || ''}`)
    } catch (error) {
      alert(error);
    }
  }

  addAssignedCommission(payload: any) {
    try {
      return this.http
        .post(this.addAssignedCommissionUrl, payload)
    } catch (error) {
      alert(error);
    }
  }

  getAssignedCommissions(targetId: any) {
    if (!targetId) return;
    try {
      return this.http
        .get(`${this.getAssignedCommissionsUrl}${targetId}`)
    } catch (error) {
      alert(error);
    }
  }

  deleteAssignedCommission(id: any, userId: any) {
    try {
      return this.http
        .delete(`${this.deleteAssignedCommissionUrl}${id}/${userId}`)
    } catch (error) {
      alert(error);
    }
  }

  addCommissionProfile(payload: any) {
    try {
      return this.http
        .post(this.addCommissionProfileUrl, payload)
    } catch (error) {
      alert(error);
    }
  }

  getCommissionProfiles(queryString?: any) {
    try {
      return this.http
        .get(`${this.getCommissionProfilesUrl}?${queryString || ''}`)
    } catch (error) {
      alert(error);
    }
  }

  updateCommissionProfile(id: any, payload: any) {
    try {
      return this.http
        .put(`${this.updateCommissionProfileUrl}${id}`, payload)
    } catch (error) {
      alert(error);
    }
  }

  deleteCommissionProfile(id: any) {
    try {
      return this.http
        .delete(`${this.deleteCommissionProfileUrl}${id}`)
    } catch (error) {
      alert(error);
    }
  }

  getTargetCommittals(user: any, type: any, userId: any, targetId: any, start: any, end: any, stage?: any) {
    try {
      return this.http
        .get(
          `${this.getCommittalsUrl}${user}/${type}/${userId}/${targetId}?start=${start}&end=${end}&stage=${stage || ''}`
        )
    } catch (error) {
      alert(error);
    }
  }

  getCommittals(user: any, type: any, userId: any, start: any, end: any, stage?: any, targetId?: any, subperiodId?: any) {
    try {
      return this.http
        .get(
          `${this.getCommittalsUrl}${user}/${type}/${userId}?start=${start}&end=${end}&stage=${stage || ''}&targetId=${targetId || ''}&subperiodId=${subperiodId || ''}`
        )
    } catch (error) {
      alert(error);
    }
  }

  getCompanyCommittals(type: any, targetId: any, start: any, end: any, stage?: any) {
    try {
      return this.http
        .get(
          `${this.getCommittalsUrl}${type}/${targetId}?start=${start}&end=${end}&stage=${stage || ''}`
        )
    } catch (error) {
      alert(error);
    }
  }

  addCommissionPayment(payload: any) {
    try {
      return this.http
        .post(this.addCommissionPaymentUrl, payload)
    } catch (error) {
      alert(error);
    }
  }

  getCommissionPayments(commissionId: any) {
    try {
      return this.http
        .get(`${this.getCommissionPaymentsUrl}${commissionId}`)
    } catch (error) {
      alert(error);
    }
  }

  reverseCommissionPayment(commissionId: any) {
    try {
      return this.http
        .get(`${this.reverseCommissionPaymentUrl}${commissionId}`)
    } catch (error) {
      alert(error);
    }
  }

  addCommissionProcess(payload: any) {
    try {
      return this.http
        .post(this.addCommissionProcessUrl, payload)
    } catch (error) {
      alert(error);
    }
  }

  getCommissionProcesses(commissionId: any) {
    try {
      return this.http
        .get(`${this.getCommissionProcessesUrl}${commissionId}`)
    } catch (error) {
      alert(error);
    }
  }

  reverseCommissionProcess(commissionId: any) {
    try {
      return this.http
        .get(`${this.reverseCommissionProcessUrl}${commissionId}`)
    } catch (error) {
      alert(error);
    }
  }

  addTargetFilter(payload: any) {
    try {
      return this.http
        .post(this.addTargetFilterUrl, payload)
    } catch (error) {
      alert(error);
    }
  }

  getTargetFilters(teamId: any, module: any) {
    try {
      return this.http
        .get(`${this.getTargetFiltersUrl}?teamId=${teamId}&module=${module}`)
    } catch (error) {
      alert(error);
    }
  }

  updateTargetFilter(id: any, payload: any) {
    try {
      return this.http
        .put(`${this.updateTargetFilterUrl}${id}`, payload)
    } catch (error) {
      alert(error);
    }
  }

  deleteTargetFilter(id: any) {
    try {
      return this.http
        .delete(`${this.deleteTargetFilterUrl}${id}`)
    } catch (error) {
      alert(error);
    }
  }

  convertObjectToQueryString(obj: any) {
    if (
      !obj
      || Object.keys(obj).length === 0
      || obj.constructor !== Object
    )
      return false;

    const queryString = Object.keys(obj).map(key => key + '=' + obj[key]).join('&');
    return queryString;
  }

  getActiveTargetModule() {
    return (this.router.url.split('/'))[2];
  }

  getTargetTypes() {
    return [
      {
        name: 'Revenue',
        value: 'revenue',
        counts: ['', 'deal', 'payment'],
        commissionEnabled: true
      },
      {
        name: 'Markup',
        value: 'markup',
        counts: ['', 'sales_order'],
        commissionEnabled: true
      },
      {
        name: 'Product/Service Revenue',
        value: 'product_revenue',
        counts: ['', 'invoice', 'sales_order'],
        commissionEnabled: true
      },
      {
        name: 'Product/Service Quantity',
        value: 'product_quantity',
        counts: ['', 'invoice', 'sales_order'],
        commissionEnabled: false
      },
      {
        name: 'Contact',
        value: 'contact',
        commissionEnabled: false
      },
      {
        name: 'Company',
        value: 'company',
        commissionEnabled: false
      },
      // {
      //   name: 'Lead',
      //   value: 'lead',
      //   commissionEnabled: false
      // }
    ];
  }

  getTargetType(type: any) {
    let result: any = {
      name: null,
      value: null,
    };
    if (type) {
      const type_array = this.getTargetTypes().filter(
        type_obj => { return type_obj.value === type }
      );
      result = type_array[0] || result;
    }
    return result;
  }


  getTargetTypesDropdown() {
    const target_types = this.getTargetTypes();
    return new Observable(observer => {
      observer.next(
        target_types.map(e => {
          return { id: e.value, description: e.name };
        })
      );
    });
  }

  getTargetStages() {
    return [
      {
        name: 'Select Stage',
        value: ''
      },
      {
        name: 'on deal won',
        value: 'deal'
      },
      {
        name: 'on invoice creation',
        value: 'invoice'
      },
      {
        name: 'on payment collection',
        value: 'payment'
      },
      {
        name: 'on sales order approval',
        value: 'sales_order'
      }
    ];
  }

  getTargetStage(stage: any) {
    let result: any = {
      name: null,
      value: null,
    };
    if (stage) {
      const stage_array = this.getTargetStages().filter(
        stage_obj => { return stage_obj.value === stage }
      );
      result = stage_array[0] || result;
    } else {
      result.name = 'none';
      result.value = 'none';
    }
    return result;
  }

  getTargetStagesDropdown(targetType?: any) {
    let target_stages = this.getTargetStages();
    if (targetType) {
      const [target_type] = this.getTargetTypes().filter(type => { return type.value === targetType });
      target_stages = (target_type.counts || []).map(type => {
        const [target_count] = this.getTargetStages().filter(stage => { return stage.value === type })
        return target_count;
      });
    }
    return new Observable(observer => {
      observer.next(
        target_stages.map(e => {
          return { id: e.value, description: e.name };
        })
      );
    });
  }

  getSalesPersons() {
    const type = 5;
    return new Promise((resolve, reject) => {
      this.salesPersonService.fetchSalesperson(type)
        .subscribe(response => {
          resolve(response);
        },
          error => {
            reject(error);
          });
    });
  }

  getTeams() {
    return new Promise((resolve, reject) => {
      this.teamsService.getTeamsByOrganization(3)
        .subscribe(response => {
          resolve(response);
        },
          error => {
            reject(error);
          });
    });
  }

  async updateArrayWithSalesPersonObj(key: any, array: any) {
    const salespersons: any = await this.getSalesPersons();
    return new Promise((resolve, reject) => {
      resolve(
        array.map((obj: any) => {
          const salesperson = (salespersons.filter((e: any) => {
            return e.id === Number(obj[key]);
          }))[0];
          obj.creator = salesperson || { name: '--' };
          obj.creator_name = obj.creator.name;
          return obj;
        })
      );
    });
  }

  async updateArrayWithTeamObj(key: any, array: any) {
    const teams: any = await this.getTeams();
    return new Promise((resolve, reject) => {
      resolve(
        array.map((obj: any) => {
          const team = (teams.filter((e: any) => {
            return e.teamID === Number(obj[key]);
          }))[0];
          obj.team = team || { teamName: '--' };
          obj.team_name = obj.team.teamName;
          return obj;
        })
      );
    });
  }
  updateSubPeriodCurrencyRates(payload: any, id: any) {
    try {
      return this.http
        .put(this.updateSubPeriodCurrencyRatesUrl + `${id}`, payload)
    } catch (error) {
      alert(error);
    }
  }
  getCompamyTargetByID(id: any) {
    return this.http
      .get(this.getCompanyTargetByIDUrl + `${id}`)
  }

  getAssignedTargetByID(id: any) {
    return this.http
      .get(this.getAssignedTargetByIDUrl + `${id}`)
  }
}
